import React from "react";
import { Stack, Avatar, Typography } from "@mui/material";
import { fullName, kFormatter } from "../../constants/function";
import { Images } from "../../assets/common";
import { useHistory } from "react-router-dom";
export default function CommonRow({ row }) {
  const history = useHistory();
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Avatar
        src={
          row && row["profilePic"]
            ? row["profilePic"]["filePath"]
            : Images.dummy1
        }
      />
      <Stack>
        <Typography
          className="fs-15 _cp"
          onClick={() => history.push(`/app/ArtistProfile/${row["_id"]}`)}
        >
          {row["fullName"]}
        </Typography>
        <Typography className="fs-13 faded">
          {kFormatter(row["followers"] ? row["followers"] : 0)} Followers
        </Typography>
      </Stack>
    </Stack>
  );
}
